<template>
    <el-row>
        <div class="queryParamStyle">
            <el-row>
                <el-form :model="queryParams" ref="queryParams" :inline="true" label-width="100px">
                    <el-col :span="10">
                        <el-form-item label="企业名称：" prop="entname">
                            <el-input
                                    v-model="queryParams.entname"
                                    placeholder="请输入企业名称"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="所属区域：" prop="jdname">
                            <el-input
                                    v-model="queryParams.jdname"
                                    placeholder="请选择所属区域"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="招聘形式：" prop="recruitmentForm">
                            <el-input
                                    v-model="queryParams.recruitmentForm"
                                    placeholder="请输入招聘形式"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="岗位名称：" prop="postName">
                            <el-input
                                    v-model="queryParams.postName"
                                    placeholder="请输入岗位名称"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="需求专业：" prop="demandSpecialty">
                            <el-input
                                    v-model="queryParams.demandSpecialty"
                                    placeholder="请输入需求专业"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="需求人数：" prop="demandNumber">
                            <el-input
                                    v-model="queryParams.demandNumber"
                                    placeholder="请输入需求人数"
                                    clearable
                                    size="small"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="mini" @click="getList"
                                       style="margin-right: 20px">搜 索
                            </el-button>
                            <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getList"
                                       style="margin-right: 20px">重 置
                            </el-button>
                            <el-button type="primary" icon="el-icon-position" size="mini"
                                       @click="toOpenPage('/main/xwqyczfw/zpxqfbForm')" style="margin-right: 20px">发 布
                            </el-button>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </div>

        <el-divider></el-divider>
        <!--
        <div class="search-page">
           <div class="search-page-order">
             <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='zhpx'}" @click="handleOrder('zhpx')">综合排序</el-button>
             <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='fbsj'}" @click="handleOrder('fbsj')">
               发布时间<i class="el-icon-top" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='fbsj'"></i>
               <i class="el-icon-bottom" v-else></i>
             </el-button>
             <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='rd'}" @click="handleOrder('rd')">
               热度<i class="el-icon-top" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='rd'"></i>
               <i class="el-icon-bottom" v-else></i>
             </el-button>
           </div>
         </div>
         <el-divider></el-divider>
         -->

        <!--
        其次判断当前登录用户是否登录了，
        如果没有登录，那么企业招聘信息不再显示，默认为隐藏。
        当登录用户登录之后，且登录用户是企业用户，那么企业招聘信息菜单显示出来，且只能查看到自己发布的招聘信息
        -->
        <div class="search-table">
            <el-table v-loading="loading" :data="list" tooltip-effect="light"
                      :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                <el-table-column label="岗位名称" align="center" prop="postName"></el-table-column>
                <el-table-column label="招聘形式" align="center" prop="recruitmentForm"
                                 :formatter="recruitmentFormFormat"></el-table-column>
                <el-table-column label="企业名称" header-align="center" align="center" prop="entname">
                    <template slot-scope="scope">
                        <el-link :underline="false" @click="openDetail(scope.row.recid)">{{ scope.row.entname }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="需求人数" align="center" prop="demandNumber"></el-table-column>
                <el-table-column label="联系人" align="center" prop="lxr">
                    <template slot-scope="scope">
                        <el-tag v-if="!isLoginState">登录后查看</el-tag>
                        <span v-if="isLoginState">{{scope.row.lxr}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="联系方式" align="center" prop="tel">
                    <template slot-scope="scope">
                        <el-tag v-if="!isLoginState">登录后查看</el-tag>
                        <span v-if="isLoginState">{{scope.row.tel}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="search-page-page">
            <el-pagination class="pagination"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page.sync="queryParams.pageNum"
                           :page-size="queryParams.pageSize"
                           :hide-on-single-page="true"
                           layout="total, prev, pager, next"
                           :total="total"
                           @pagination="getList">
            </el-pagination>
        </div>

    </el-row>

</template>
<script>
    import {listQyzpxx, getQyzpxx, delQyzpxx, addQyzpxx, updateQyzpxx, exportQyzpxx} from "@/api/xwqy/qyzpxx";
    import {updatePvNum} from "@/api/itempv/pv";

    export default {
        //首页
        name: 'yxfmzlcx',
        data() {
            return {
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list: [],
                isLoginState: undefined,
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    orderBy: "zhpx",
                    isAsc: "asc",
                },
                recruitmentForms: [],
            }
        },
        created() {
            this.getDicts("qyzpxx_recruitment_forms").then(response => {
                this.recruitmentForms = response.data;
            });
            this.getList();
            this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
            if(this.loginUser != null && this.loginUser != undefined){
                this.isLoginState = true;
            }
            updatePvNum("xwqycz_rcdj_qyzpxx").then(response => {
                //pv 点击人才对接企业招聘信息
            });
        },
        methods: {
            // recruitmentFormFormat(row, column){
            //   let actions = [];
            //   let datas = this.recruitmentForms;
            //   let value = row.recruitmentForm;
            //   Object.keys(datas).map((key) => {
            //     if (datas[key].value == ('' + value)) {
            //       actions.push(datas[key].label);
            //       return false;
            //     }
            //   })
            //   return actions.join('');
            // },
            recruitmentFormFormat(row, column) {
                return this.selectDictLabel(this.recruitmentForms, row.recruitmentForm);
            },
            handleOrder(code) {
                if (this.queryParams.orderBy == code) {
                    if (this.queryParams.isAsc == "asc") {
                        this.queryParams.isAsc = "desc";
                    } else {
                        this.queryParams.isAsc = "asc";
                    }
                }
                if (code == "zhpx") {
                    this.queryParams.isAsc = "asc";
                }
                this.queryParams.orderBy = code;
                this.getList();
            },
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.getList();
            },
            getList() {
                this.loading = true;
                listQyzpxx(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
            },
            /** 搜索按钮操作 */
            handleQuery() {
                this.queryParams.pageNum = 1;
                this.getList();
            },
            openDetail(item) {
                this.$router.push({
                    path: '/main/xwqyczfw/rcdj/qyzpxxDetail/' + item
                })
                this.$store.commit('SET_MAININDEX', '/main/xwqyczfw/rcdj');
            },
            toOpenPage(url){
                this.$router.push({
                  path: url
                })
                this.$store.commit('SET_MAININDEX', url);
            },
        }
    }
</script>
<style scoped>
    .app-container {
        padding: 0px 15px 20px;
        background-color: #ffffff;
    }

    .el-form-item {
        margin-bottom: 8px;
    }

    .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 8px 0;
    }

    .queryParamStyle {
        padding-top: 10px;
        background-color: #F5F5F5;
    }

    .search-page {
        background-color: #ffffff;
        display: flex;
    }

    .search-page-order {
        display: flex;
    }

    .order-filed {
        flex: 1;
        padding: 0px 15px;
        color: #000000;
    }

    .search-table {
        margin: 0px;
        padding: 15px;
        background-color: #ffffff;
    }

    .search-page-page {
        flex: 1;
        text-align: center;
    }
</style>
